import styles from './loading-animation.module.css';

const USE_CLASSES = {
    'suggested-price': styles.suggestedPrice,
    'summary': styles.summary,
    'screen-loading': styles.screenLoading

}

export function LoadingAnimation({ use } : {
    use?: 'suggested-price' | 'summary' | 'screen-loading'
}) {
    const useClass = USE_CLASSES[use ?? 'suggested-price'];
    return <div className={`${styles.loaderWrapper} ${useClass}`}>
        <div className={styles.loader}></div>
    </div>
}